import type { FormattedHeadings, HeadingsMap, TableOfContents } from '@models/Toc';

export function getFormattedHeadings(headingsMap: HeadingsMap): FormattedHeadings {
  return Object.values(headingsMap).reduce((acc, current) => [...acc, ...current], []);
}

export function getPlainHeadings(tableOfContents: TableOfContents): TableOfContents {
  const traverse = (toc: TableOfContents): TableOfContents =>
    toc.flatMap(({ items, ...restHeading }) => [restHeading, ...(items ? traverse(items) : [])]);

  return traverse(tableOfContents);
}
